import React, { ReactElement, useEffect } from 'react';

import { useContent } from '@interstellar/react-app-content';
import ThreeStepsToRegister from 'components/threeStepsToRegister/ThreeStepsToRegister';

import { ThreeStepsToRegisterDelegateAccessContent } from './ThreeStepsToRegisterDelegateAccessContent';
import { JOURNEY_STEPS } from '../../constants/analytics.constants';
import * as Analytics from '../../utils/analytics';

// This component will render when the user is not a full power signatory(delegate access)
function ThreeStepsToRegisterDelegateAccess(): ReactElement {
  useEffect(() => {
    Analytics.setPageLoadEvent(
      JOURNEY_STEPS.ONLINE_REGISTRATION.THREE_STEPS_TO_REGISTER,
    );
  }, []);
  const { threeStepsToRegisterDelegateAccessContent } =
    useContent<ThreeStepsToRegisterDelegateAccessContent>();

  return (
    // Reusable component created for 'Three Steps To Register - Delegate access' and 'Three Steps To Register Approval' pages
    <ThreeStepsToRegister
      data={threeStepsToRegisterDelegateAccessContent}
      externalLink
    />
  );
}

export default ThreeStepsToRegisterDelegateAccess;
